export interface Testimonial {
  initials: string
  name: string
  location: string
  quote: string
}

export interface Tomo {
  emoji: string
  title: string
  description: string
}

export interface Bono {
  number: string
  title: string
  description: string
  price: string
}

export interface ComparisonRow {
  situation: string
  without: string
  with: string
}

export interface CostRow {
  without: string
  cost: string
}

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    quote:
      'Organicé todo el año en una tarde. El Método IEC me salvó porque mis alumnos no tienen todos los elementos.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    quote:
      'El bimestre de invierno es exactamente lo que mis alumnas necesitaban en julio.',
  },
  {
    initials: 'RM',
    name: 'Romina M.',
    location: 'Buenos Aires',
    quote: 'La escalera de niveles del Bono 4 transformó mis grupos mixtos.',
  },
]

export const finalTestimonials: Testimonial[] = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    quote:
      'El Mapa de Adaptaciones me salvó con los grupos mixtos. Todos trabajan al mismo tiempo en su versión.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    quote: 'El Tomo de Invierno es único. El grupo de julio fue el mejor del año.',
  },
  {
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Rosario',
    quote:
      'El Kit de Mensajes cambió la relación con mis alumnos. Mis clases se sienten más profesionales desde antes de empezar.',
  },
  {
    initials: 'NC',
    name: 'Natalia C.',
    location: 'Tucumán',
    quote:
      'El Método IEC fue una revolución. Doy clases a domicilio y ya nunca me falta nada.',
  },
]

export const painPoints: string[] = [
  'Domingos buscando ejercicios sin progresión clara',
  'Grupos mixtos sin material diferenciado: perdés a todos',
  'Sin sustitutos IEC organizados: las clases dependen del equipamiento',
  'Sin sistema de fidelización: los alumnos se van en invierno y en noviembre',
  'Sin frases para corregir: los alumnos se frustran y desconectan',
  'El mismo ciclo, el domingo que viene',
]

export const tomos: Tomo[] = [
  {
    emoji: '📘',
    title: 'Tomo 1 — Fundamentos y Transiciones',
    description:
      'Respiración, core, ejercicios base y Método IEC desde el primer día.',
  },
  {
    emoji: '📗',
    title: 'Tomo 2 — Fuerza y Resistencia',
    description:
      'Progresiones de fuerza, circuitos y trabajo con sustitutos IEC como peso.',
  },
  {
    emoji: '📙',
    title: 'Tomo 3 — Flexibilidad y Apertura',
    description:
      'Liberación miofascial, apertura de cadera y movilidad de columna.',
  },
  {
    emoji: '📕',
    title: 'Tomo 4 — Pilates Especial Invierno',
    description:
      'Calentamiento de invierno, trabajo de profundidad y bienestar emocional.',
  },
  {
    emoji: '📓',
    title: 'Tomo 5 — Dinámicas y Coreografías',
    description:
      'Tres coreografías completas, trabajo en dúos y clases con ritmo musical.',
  },
  {
    emoji: '📔',
    title: 'Tomo 6 — Cierre de Año y Wellness Mental',
    description:
      'Integración, protocolo de clase de cierre y sistema de reinscripción.',
  },
]

export const tomoIncludes: string[] = [
  '30 sesiones planificadas listas para usar',
  'Tres versiones por ejercicio: principiante, intermedio y avanzado',
  'Sustitutos IEC para cada elemento del bimestre',
  'Fichas de ejercicios con instrucción y correcciones',
  'Instrucciones de voz listas para decir en clase',
  'Adaptaciones para grupos mixtos',
  '100% pensado para la realidad argentina',
]

export const bonos: Bono[] = [
  {
    number: '01',
    title: 'Checklist Profe Lista en 10 Minutos',
    description:
      'Preparás cualquier clase en menos de 10 minutos sin improvisar.',
    price: '$8.000',
  },
  {
    number: '02',
    title: 'Banco de Frases Pro para Corregir Sin Frustrar',
    description: '150 frases listas para guiar, corregir y motivar.',
    price: '$10.000',
  },
  {
    number: '03',
    title: 'Tracker Profesional de Progreso del Alumno',
    description:
      'Registrá avances reales y mostráselos para que valoren más tus clases.',
    price: '$9.000',
  },
  {
    number: '04',
    title: 'Mapa Express de Adaptaciones por Nivel',
    description: 'Cualquier ejercicio en versión P, I o A en segundos.',
    price: '$8.000',
  },
  {
    number: '05',
    title: 'Kit de Mensajes WhatsApp para Alumnos',
    description: 'Más de 80 mensajes listos para copiar y enviar.',
    price: '$9.000',
  },
  {
    number: '06',
    title: 'Guía Rápida de Sustitutos IEC Seguros',
    description:
      'Reemplazá cualquier elemento con objetos de casa sin perder calidad.',
    price: '$9.000',
  },
]

export const estudioProRows: ComparisonRow[] = [
  {
    situation: 'Alguien pregunta el precio',
    without: 'Improvisás y cobrás menos',
    with: 'Script listo y precio calculado',
  },
  {
    situation: 'Un alumno falta sin avisar',
    without: 'Sin reglas claras',
    with: 'Política comunicada desde el día uno',
  },
  {
    situation: 'Querés subir el precio',
    without: 'Lo postergás',
    with: 'Mensaje y timing exacto',
  },
  {
    situation: 'Instagram sin dirección',
    without: 'No publicás o publicás sin resultado',
    with: '30 ideas de contenido que venden',
  },
  {
    situation: 'Alumno en riesgo de abandonar',
    without: 'Esperás que vuelva solo',
    with: 'Script de seguimiento listo',
  },
  {
    situation: 'Fin de mes sin saber cuánto ganaste',
    without: 'Incertidumbre que agota',
    with: 'Planilla actualizada en 10 minutos',
  },
]

export const costRows: CostRow[] = [
  {
    without: '3 horas de planificación × 48 semanas',
    cost: '144 horas de tu vida por año',
  },
  {
    without: 'Sin progresiones claras',
    cost: 'Alumnos que sienten que no avanzan y abandonan',
  },
  {
    without: 'Sin sustitutos IEC',
    cost: 'Clases limitadas por equipamiento',
  },
  {
    without: 'Sin fidelización',
    cost: 'Alumnos que se van en invierno y en noviembre',
  },
  {
    without: 'Domingo buscando ideas',
    cost: 'El mismo ciclo, el año que viene',
  },
]

export const faqs: { question: string; answer: string }[] = [
  {
    question: '¿Sirve para todos los niveles?',
    answer:
      'Sí. Cada sesión tiene tres versiones: principiante, intermedio y avanzado. El Bono 4 tiene el mapa completo para adaptar cualquier ejercicio en segundos.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después del pago recibís el link de descarga por correo. Acceso completo en menos de 5 minutos.',
  },
  {
    question: '¿Qué lo diferencia de buscar en Instagram?',
    answer:
      'Instagram da ejercicios sueltos. El Super Kit da un sistema anual progresivo donde cada sesión construye sobre la anterior. Es la diferencia entre piezas sueltas y el rompecabezas armado.',
  },
  {
    question: '¿Funciona para clases online y a domicilio?',
    answer:
      'Sí. El Método IEC fue diseñado exactamente para eso. La guía de sustitutos te permite dar una clase de calidad con lo que el alumno tiene en su casa.',
  },
]
